module.exports = __webpack_public_path__ + "img/icon-student.bf7a14e8.svg";